import { render, staticRenderFns } from "./ResellerClients.vue?vue&type=template&id=72fb4a3f&"
import script from "./ResellerClients.vue?vue&type=script&lang=js&"
export * from "./ResellerClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports